import { TriggerEvent } from 'scripts/type'
import { postMessage } from 'scripts/utils'
import { MutableRef } from 'preact/hooks'
import { useContext } from 'preact/compat'
import BaseContext from 'contexts/base-context'

export function usePostHeightChangeMessage(
  contentDom: MutableRef<HTMLDivElement>,
  brandingDom: MutableRef<HTMLDivElement>,
  marginTop: number
) {
  const { urlToken } = useContext(BaseContext)

  const postHeightChange = (safeAreaHeight: number) => {
    const widgetHeight = contentDom.current?.offsetHeight ?? 0
    const brandingHeight = brandingDom.current?.offsetHeight ?? 0
    const height = widgetHeight + brandingHeight + marginTop + safeAreaHeight
    const message = {
      name: TriggerEvent.HeightChange,
      data: {
        height,
        campaignToken: urlToken,
        safeAreaHeight,
      },
    }
    postMessage(message)
    return height
  }

  return {
    postHeightChange,
  }
}

export function usePostSurveyHeightChangeMessage(brandingDom: MutableRef<HTMLDivElement>) {
  const { urlToken } = useContext(BaseContext)

  const postHeightChange = (fieldHeight: number, safeAreaHeight: number) => {
    const brandingHeight = brandingDom.current?.offsetHeight ?? 0
    const height = fieldHeight + brandingHeight + safeAreaHeight
    const message = {
      name: TriggerEvent.HeightChange,
      data: {
        height,
        campaignToken: urlToken,
        safeAreaHeight,
      },
    }
    postMessage(message)
    return height
  }
  return {
    postHeightChange,
  }
}
